<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedi"><em class="italic">For Rosana and Russell, heirs to the de Montfort tradition</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedi.vue?855bc368